"use client";

import { motion } from "framer-motion";

const LOGOS = ["WIRED", "FAST CO.", "VERGE", "DEZEEN", "MONOCLE", "TECHCRUNCH"];

export function Logos() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
      },
    },
  };

  return (
    <section className="border-y border-border/60 py-10 bg-background overflow-hidden">
      <motion.div 
        className="mx-auto max-w-7xl px-6 lg:px-10"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={containerVariants}
      >
        <motion.p 
          variants={itemVariants}
          className="text-center text-xs uppercase tracking-[0.25em] text-muted-foreground mb-8"
        >
          As featured in
        </motion.p>
        <div className="flex flex-wrap items-center justify-between gap-x-12 gap-y-6 opacity-70">
          {LOGOS.map((l) => (
            <motion.span
              key={l}
              variants={itemVariants}
              className="text-lg sm:text-xl font-semibold tracking-[0.2em] text-foreground/70"
            >
              {l}
            </motion.span>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
